__turbopack_context__.v({
  "className": "graphik_7b525cf8-module__r9lbzW__className",
  "variable": "graphik_7b525cf8-module__r9lbzW__variable",
});
